import { InputHTMLAttributes, forwardRef } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className = '', type = 'text', ...props },
  ref,
) {
  return (
    <input
      ref={ref}
      type={type}
      className={`
        flex h-10 w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm
        placeholder:text-foreground-muted
        focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:ring-offset-background focus-visible:border-primary
        disabled:cursor-not-allowed disabled:opacity-50
        transition-colors
        ${className}
      `}
      {...props}
    />
  );
});
